import { combineReducers } from 'redux';
import posts from './googleReducer';

export default combineReducers({
    posts: posts
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js